import { makeStateKey } from '@angular/core'

import { IEnvState } from '../models'

export const ENV_STATE_KEY = makeStateKey<IEnvState>('env')
